var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelularCor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.25 5.18521V34.8149C30.25 35.838 29.5352 36.6667 28.6528 36.6667H12.6805C12.4643 36.6629 12.2514 36.6126 12.0564 36.5191C11.8614 36.4256 11.6889 36.2912 11.5505 36.125C11.2448 35.7572 11.0793 35.2931 11.0833 34.8149V5.18521C11.0833 4.16208 11.7981 3.33337 12.6805 3.33337H28.6528C29.5352 3.33337 30.25 4.16208 30.25 5.18521Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25 10.4166V34.8166C30.25 35.8375 29.5333 36.6666 28.6542 36.6666H12.6792C12.4631 36.6626 12.2504 36.6122 12.0556 36.5187C11.8608 36.4253 11.6883 36.291 11.55 36.125C11.2446 35.7578 11.0792 35.2942 11.0833 34.8166V29.5833L30.25 10.4166Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5833 36.6666H12.75C12.308 36.6666 11.884 36.491 11.5715 36.1785C11.2589 35.8659 11.0833 35.442 11.0833 35V31.6666L30.25 31.6666V35C30.25 35.442 30.0744 35.8659 29.7618 36.1785C29.4493 36.491 29.0254 36.6666 28.5833 36.6666Z",
    fill: "#00416B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 35C21.1269 35 21.5 34.6269 21.5 34.1667C21.5 33.7065 21.1269 33.3334 20.6667 33.3334C20.2064 33.3334 19.8333 33.7065 19.8333 34.1667C19.8333 34.6269 20.2064 35 20.6667 35Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25 5.00004H11.0833C11.0833 4.55801 11.2589 4.13409 11.5715 3.82153C11.884 3.50897 12.308 3.33337 12.75 3.33337H28.5833C29.0254 3.33337 29.4493 3.50897 29.7618 3.82153C30.0744 4.13409 30.25 4.55801 30.25 5.00004Z",
    fill: "#00416B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.666656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelularCor);
export default __webpack_public_path__ + "static/media/celular-cor.f15b379f524e001b0e264fdc4d6948d4.svg";
export { ForwardRef as ReactComponent };